var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72033 14.6471V12.1891H18.2834V14.6471C18.2834 15.5521 19.017 16.2857 19.922 16.2857H21.8338C22.7389 16.2857 23.4724 15.5521 23.4724 14.6471V8.63866C23.4724 7.73365 22.7389 7 21.8338 7H19.922C19.017 7 18.2834 7.73365 18.2834 8.63866V11.0966H5.72033V8.63866C5.72033 7.73365 4.98667 7 4.08167 7H2.16991C1.2649 7 0.53125 7.73365 0.53125 8.63866V14.6471C0.53125 15.5521 1.2649 16.2857 2.16991 16.2857H4.08167C4.98667 16.2857 5.72033 15.5521 5.72033 14.6471ZM19.3758 14.6471V8.63866C19.3758 8.33698 19.6203 8.09244 19.922 8.09244H21.8338C22.1356 8.09244 22.38 8.33698 22.38 8.63866V14.6471C22.38 14.9488 22.1356 15.1933 21.8338 15.1933H19.922C19.6203 15.1933 19.3758 14.9488 19.3758 14.6471ZM2.16991 8.09244C1.86823 8.09244 1.62369 8.33698 1.62369 8.63866V14.6471C1.62369 14.9488 1.86823 15.1933 2.16991 15.1933H4.08167C4.38335 15.1933 4.62789 14.9488 4.62789 14.6471V8.63866C4.62789 8.33698 4.38335 8.09244 4.08167 8.09244H2.16991Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxle);
export default __webpack_public_path__ + "static/media/axle.4847ca8eee27836038be46781dd04844.svg";
export { ForwardRef as ReactComponent };